module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/fb-icon-9371d7dcaff28335ca9c094d9890bbd9.png";